<template>
  <!-- 全景 -->
  <section class="qj-box">
    <div class="house-title">
      <img
        src="https://images.jianshankeji.com/timepark_select_housetitle.svg"
        alt=""
      />
    </div>
    <div class="back-icon" @click="backSelect">
      <img src="~@/assets/Back.svg" alt="" srcset="" />
    </div>
    <div class="house-show">
      <iframe
        class="iframe-box"
        src="https://zsparkweb.jianshankeji.com/huxing"
        frameborder="0"
      ></iframe>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {
    backSelect() {
      wx.miniProgram.redirectTo({
        url: "/pages/select/select", // 小程序中页面的路径
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.qj-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  .house-title {
    position: absolute;
    top: 0px;
    left: 59px;
    width: 127px;
    height: 63px;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .back-icon {
    position: absolute;
    top: 10px;
    left: 15px;
    width: 30px;
    height: 30px;
    z-index: 3;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .house-show {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    .iframe-box {
      width: 100%;
      height: 100%;
    }
  }
}
</style>